/**
 * 薄包装 — 实现已迁入 @xt/Nav（2.0.37+）
 */
import React from "react";
import { AccountShell as NavAccountShell, AccountPageHeader } from "@xt/Nav";

export { AccountPageHeader };
export { useAccountHeaderActions } from "@xt/Nav/src/accountShell/accountHeaderActions";

export default function AccountShell({ tabKey, children }) {
  return <NavAccountShell tabKey={tabKey}>{children}</NavAccountShell>;
}
